import EventsLoggerService from '../services/events-logger.service';

// Event types constants
export const EVENT_TYPES = {
    SIGNUP: 'SIGNUP',
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    PLAN_SELECTION: 'PLAN_SELECTION',
    PAYMENT: 'PAYMENT',
    VERIFICATION: 'VERIFICATION',
    ERROR: 'ERROR',
    PAGE_VIEW: 'PAGE_VIEW',
    BUTTON_CLICK: 'BUTTON_CLICK',
    FORM_SUBMIT: 'FORM_SUBMIT',
    BUNDLE_PURCHASE: 'BUNDLE_PURCHASE'
} as const;

// Signup flow constants
export const SIGNUP_FLOWS = {
    PRICING_PAGE: 'PRICING_PAGE',
    HOMEPAGE: 'HOMEPAGE'
} as const;

// Signup steps constants
export const SIGNUP_STEPS = {
    FORM: 'FORM',
    PAYMENT: 'PAYMENT',
    VERIFICATION: 'VERIFICATION',
    COMPLETED: 'COMPLETED'
} as const;

// Interface for signup event data
export interface SignupEventData {
    step: string;
    password: string;
    planId: string;
    planUnits: string;
    SignupFlow: string;
    [key: string]: any; // Allow additional properties
}

// Interface for generic event data
export interface EventData {
    [key: string]: any;
}

/**
 * Log a generic event with any data structure
 * @param email - User's email address
 * @param eventType - Type of event (use EVENT_TYPES constants)
 * @param eventData - Event data
 * @param additionalData - Any additional data to include
 */
export const logEvent = async (
    email: string,
    eventType: string,
    eventData: EventData,
) => {
    try {
        const finalEventData = {
            ...eventData,
            timestamp: new Date().toISOString()
        };
        
        await EventsLoggerService.logEvent(email, eventType, finalEventData);
        console.log(`${eventType} event logged successfully:`, finalEventData);
        return true;
    } catch (error: any) {
        console.error(`Error logging ${eventType} event:`, error);
        return false;
    }
};

/**
 * Log a page view event
 * @param email - User's email address
 * @param pageName - Name of the page being viewed
 * @param additionalData - Any additional data to include
 */
export const logPageView = async (
    email: string,
    pageName: string,
    additionalData?: Record<string, any>
) => {
    return logEvent(email, EVENT_TYPES.PAGE_VIEW, {
        page: pageName,
        url: window.location.href,
        referrer: document.referrer
    });
};
